"use client";
import Link from "next/link";
import LoginForm from "@/components/partials/auth/login-form";
import useDarkMode from "@/hooks/useDarkMode";
import { useSearchParams } from "next/navigation";

// image import

const Login = ({ redirect = null, embedded = false, onSuccess = null, onShowRegister = null }) => {
  const [isDark] = useDarkMode();
  const searchParams = useSearchParams()
  const redirectUrl = searchParams.get('redirect')

  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess();
      return;
    }
    if (redirect) {
      window.location.href = redirect;
      return;
    }
    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }
    window.location.href = "/";
  };

  const loginContent = (
    <>
      <div className="text-center 2xl:mb-10 mb-4">
        <h4 className="font-medium">Sign in</h4>
        <div className="text-slate-500 text-base">
          Sign in to your account to start using Eyam
        </div>
      </div>
      <LoginForm onSuccess={handleSuccess} />

      <div className="md:max-w-[345px] mx-auto font-normal text-slate-500 dark:text-slate-400 mt-12 uppercase text-sm">
        Don’t have an account?{" "}
        {embedded ? (
          <button
            type="button"
            onClick={onShowRegister}
            className="text-slate-900 dark:text-white font-medium hover:underline"
          >
            Sign up
          </button>
        ) : (
          <Link
            href="/register"
            className="text-slate-900 dark:text-white font-medium hover:underline"
          >
            Sign up
          </Link>
        )}
      </div>
    </>
  );

  if (embedded) {
    return (
      <div className="mx-auto w-full max-w-xl rounded-3xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-800 md:p-10">
        {loginContent}
      </div>
    );
  }

  return (
    <>
      <div className="loginwrapper">
        <div className="lg-inner-column">
          <div className="left-column relative z-[1]">
            <div className="max-w-[520px] pt-20 ltr:pl-20 rtl:pr-20">
              <Link href="/">
                <img
                  src={
                    isDark
                      ? "/assets/eyamLogo.png"
                      : "/assets/images/eyamLogo.png"
                  }
                  alt=""
                  className="mb-10 md:w-1/3 w-1/2"
                />
              </Link>
              <h4 className="!text-xl text-slate-800 dark:text-slate-400 font-bold">
                Welcome to Eyam {" "}<br></br>
                <span className="text-lg !text-black font-normal ">
                  The only platform that turns social media views and attention to real cash. Promote business and get paid.
                </span>
              </h4>
            </div>
            <div className="absolute left-0 2xl:bottom-[-100px] bottom-[-100px] h-full w-full z-[-1]">
              <img
                src="/assets/images/login.svg"
                alt=""
                className="h-full w-1/2 object-contain mx-auto"
              />
            </div>
          </div>
          <div className="right-column relative">
            <div className="inner-content h-full flex flex-col bg-white dark:bg-slate-800">
              <div className="auth-box h-full flex flex-col justify-center">
                <div className="mobile-logo text-center mb-6 lg:hidden block">
                  <Link href="/">
                    <img
                      src={
                        isDark
                          ? "/assets/eyamLogo.png"
                          : "/assets/images/eyamLogo.png"
                      }
                      alt=""
                      className="mx-auto w-1/2"
                    />
                  </Link>
                </div>
                {loginContent}
              </div>
              <div className="auth-footer text-center">
                Copyright 2024, Eyam All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
